import { type DocumentVariableMetadata, documentVariable } from './document-variable'

/**
 * Metadatos de MONEDA. La moneda viene de la negociación (no del número), por eso son variables y
 * no máscaras: exponen las piezas sueltas —símbolo, singular, plural— para redacción dinámica.
 */

export const CURRENCY_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'moneda_simbolo',
    label: 'Moneda - Símbolo',
    category: 'currency',
    type: 'string',
    description: 'Símbolo de la moneda',
    example: 'Q'
  }),
  documentVariable({
    key: 'moneda_singular',
    label: 'Moneda - Nombre singular',
    category: 'currency',
    type: 'string',
    description: 'Nombre de la moneda en singular',
    example: 'QUETZAL'
  }),
  documentVariable({
    key: 'moneda_plural',
    label: 'Moneda - Nombre plural',
    category: 'currency',
    type: 'string',
    description: 'Nombre de la moneda en plural',
    example: 'QUETZALES'
  }),
  documentVariable({
    key: 'centavo_singular',
    label: 'Centavo - Singular',
    category: 'currency',
    type: 'string',
    description: 'Nombre del centavo en singular',
    example: 'Centavo de Quetzal'
  }),
  documentVariable({
    key: 'centavo_plural',
    label: 'Centavo - Plural',
    category: 'currency',
    type: 'string',
    description: 'Nombre del centavo en plural',
    example: 'Centavos de Quetzal'
  })
]
